import { API_URLS } from 'app-constants/api';
import { ApiRequest } from 'types';
import secondaryHttpService from 'services/secondary-http.service';
import { Params } from 'store/wim/comparative-analysis/type';

export const getAnalysis = ({ ...params }: Params) => {
  return secondaryHttpService.get(API_URLS.comparativeAnalysis(), { params: { params } });
};

export const exportAnalysis = ({ ...params }: Params) => {
  return secondaryHttpService.get(API_URLS.exportComparativeAnalysis(), { params: { params } });
};
